import { Box, Typography } from "@mui/material";
import ReadOnlyIntervention from "./ReadOnlyIntervention";
import SectionCollapsible from "../../../common/SectionCollapsible";

export type Intervention = {
  action: Array<string>;
  ecosystem: Array<string>;
};

export function ReadOnlyInterventionsContainer({
  interventions = [],
}: {
  interventions: Array<Intervention>;
}) {
  return (
    <Box data-testid="read-only-interventions-container">
      <SectionCollapsible label="Interventions">
        {interventions &&
          interventions.map((intervention) => (
            <ReadOnlyIntervention
              key={`${intervention.action}.${intervention.ecosystem}`}
              intervention={intervention}
            />
          ))}
        {!interventions?.length && (
          <Typography variant="body1" sx={{ paddingTop: 2 }}>
            No interventions found.
          </Typography>
        )}
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyInterventionsContainer;
